<template>
  <svg
    class="qr"
    :viewBox="`0 0 ${size} ${size}`"
    role="img"
    :aria-label="`QR code for ${value}`"
    shape-rendering="crispEdges"
  >
    <rect x="0" y="0" :width="size" :height="size" class="qr__ground" />
    <path :d="path" class="qr__ink" />
  </svg>
</template>

<script>
import qr from 'qrcode-generator';

// The join link as a square anyone can point a camera at. Drawn as ONE svg
// path (a rect per dark module would be ~1200 nodes); the quiet border is
// four modules, which is what readers expect to find.
const QUIET = 4;

export default {
  name: 'QrCode',
  props: { value: { type: String, required: true } },
  computed: {
    code() {
      // Type 0 = smallest that fits; M = 15% error correction, which is
      // plenty for a screen and keeps the modules big across a room.
      const c = qr(0, 'M');
      c.addData(this.value);
      c.make();
      return c;
    },
    count() { return this.code.getModuleCount(); },
    size() { return this.count + QUIET * 2; },
    path() {
      const parts = [];
      for (let row = 0; row < this.count; row += 1) {
        for (let col = 0; col < this.count; col += 1) {
          if (this.code.isDark(row, col)) parts.push(`M${col + QUIET} ${row + QUIET}h1v1h-1z`);
        }
      }
      return parts.join('');
    },
  },
};
</script>
